module.exports = __webpack_public_path__ + "static/img/01.8f79b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/110719/01.png
// module id = ivdG
// module chunks = 0